export default __webpack_public_path__ + "static/power_media_market-8b19aa67e67946902c554e1ac12f4224.webp";